import { render } from "./CIS-Home-Featured-CTA.vue?vue&type=template&id=5ac6cb40&scoped=true"
import script from "./CIS-Home-Featured-CTA.vue?vue&type=script&lang=js"
export * from "./CIS-Home-Featured-CTA.vue?vue&type=script&lang=js"

import "./CIS-Home-Featured-CTA.vue?vue&type=style&index=0&id=5ac6cb40&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ac6cb40"]])

export default __exports__